import { createContext } from 'react'

const SidebarContext = createContext({
  mobileOpen: false,
  setMobileOpen: () => {},
  logout: () => {}
})

export default SidebarContext
